<nav
    role="navigation"
    id="sidebarPrimary"
    class="navbar primary-nav navbar-expand-lg d-flex align-items-start ps-0 pt-0 pb-0 h-100"
    aria-label="Primary sidebar navigation"
>
    <div class="navbar-collapse collapse show w-100">
        <app-nav-list
            [hideNavLinks]="hideNavLinks"
            (navItemClicked)="navItemClicked($event)"
            class="w-100 h-100"
        ></app-nav-list>
    </div>
</nav>
